import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Panel, Loading, Pill } from "@/components/kit";
import { History, ArrowRight } from "lucide-react";

export default function Audit() {
  const { data, isLoading } = useQuery({
    queryKey: ["audit"],
    queryFn: async () => (await api.get("/audit")).data,
  });
  if (isLoading || !data) return <Loading label="Loading audit explorer…" />;

  return (
    <div>
      <PageHeader title="Audit Explorer" subtitle="Immutable versioning with before/after comparison and calculation hash" />
      <Panel testid="audit-panel" subtitle={`${data.logs.length} audit events`}>
        <div className="space-y-3">
          {data.logs.map((l, i) => (
            <div key={l.id} data-testid={`audit-row-${i}`}
              className="flex items-start gap-4 p-4 rounded-lg border border-slate-200 hover:border-[#00529B] transition-colors">
              <div className="w-9 h-9 rounded-lg adani-navy-gradient flex items-center justify-center text-white shrink-0">
                <History size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-slate-800 capitalize">{l.entity}</span>
                  <Pill>{l.action}</Pill>
                  <span className="text-xs text-slate-400">{l.actor}</span>
                </div>
                <div className="flex items-center gap-2 mt-2 text-xs text-slate-500">
                  <code className="px-2 py-0.5 rounded bg-slate-50 border border-slate-200">{JSON.stringify(l.before)}</code>
                  <ArrowRight size={13} className="text-slate-300" />
                  <code className="px-2 py-0.5 rounded bg-emerald-50 border border-emerald-200">{JSON.stringify(l.after)}</code>
                </div>
                <div className="text-[11px] text-slate-400 mt-1.5 font-mono">hash: {l.hash?.slice(0, 24)}…</div>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
